import { render, staticRenderFns } from "./VekaletDetayView.vue?vue&type=template&id=30e1654a&scoped=true"
import script from "./VekaletDetayView.vue?vue&type=script&lang=ts"
export * from "./VekaletDetayView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e1654a",
  null
  
)

export default component.exports